import React from 'react';


function ItemIcon(props) {
/*
    if (props.fg === true) {
      return <div className={props.cssClass}>&nbsp;</div>;
    } else return null;
*/
  if (props.fg === true) {
    return <p className={props.cssClass}>{props.text}</p>;
  } else 
    return null;
}

export default ItemIcon;